import {AnchorHTMLAttributes, ButtonHTMLAttributes, ReactElement, useState} from "react";
import FrameOneAutoPanel from "../autoPanelComponents/FrameOneAutoPanel";
import FrameAutoPanelHeader from "../autoPanelComponents/FrameAutoPanelHeader";
import FrameAutoPanelBody from "../autoPanelComponents/FrameAutoPanelBody";
import FrameButton from "../../buttons/FrameButton";
import DOMPurify from "dompurify";
import {useCopyToClipboard} from "@/hooks/useCopyToClipboard";
import {FaGlobe, FaRegCopy} from "react-icons/fa";
import Toast from "@/components/Toast";

interface Props {
    description?: string;
    targetUrl: string;
    isOpen: boolean;
    toggle: () => void;
}

function PromoTokenExternalUrlModal(props: Props): ReactElement {
    const {copyToClipboard} = useCopyToClipboard();
    const [isCopied, setIsCopied] = useState<boolean>(false);

    return (
        <>
            <Toast
                variant="info"
                message='Copied!'
                isOpen={isCopied}
                showButton={false}
                onDismiss={() => setIsCopied(false)}
                duration={3000}
            />
            <FrameOneAutoPanel
                isOpen={props.isOpen}
                toggle={props.toggle}
                contentClassName="promo-token-external-url-modal"
                size="sm"
            >
                <FrameAutoPanelHeader
                    title="Claim Reward"
                    toggle={props.toggle}
                />

                <FrameAutoPanelBody>

                    {props.description &&
												<div
												    className="promo-token-external-url-modal_description"
												    // eslint-disable-next-line react/no-danger
												    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.description)}}
												/>
                    }

                    <input
                        className="promo-token-external-url-modal_input"
                        readOnly={true}
                        value={props.targetUrl}
                    />

                    <div className="promo-token-external-url-modal_actions">
                        <FrameButton
                            <ButtonHTMLAttributes<HTMLButtonElement>>
                            color={"purple"}
                            size={"narrow"}
                            onClick={() => {
                                setIsCopied(true);
                                copyToClipboard(props.targetUrl);
                            }}
                            leftIcon={FaRegCopy}
                        >
                            Copy to clipboard
                        </FrameButton>

                        <FrameButton
                            <AnchorHTMLAttributes<HTMLAnchorElement>>
                            color={"purple"}
                            size={"narrow"}
                            href={props.targetUrl}
                            leftIcon={FaGlobe}
                            forwardProps={{
                                target: "_blank",
                                rel: "noopener noreferrer",
                            }}
                        >
                            Open in new tab
                        </FrameButton>
                    </div>
                </FrameAutoPanelBody>
            </FrameOneAutoPanel>
        </>
    );
}

export default PromoTokenExternalUrlModal;
